/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from '@/lib/api';

export const getDirezioneOverview = (months = 12) => api.get('/admin/direzione/overview', { params: { months } }).then((r) => r.data);
export const getDirezioneSettings = () => api.get('/admin/direzione/settings').then((r) => r.data);
export const putDirezioneSettings = (body) => api.put('/admin/direzione/settings', body).then((r) => r.data);

export const getBackupStatus = () => api.get('/admin/backup/status').then((r) => r.data);
export const putBackupSchedule = (body) => api.put('/admin/backup/schedule', body).then((r) => r.data);
export const runBackupNow = () => api.post('/admin/backup/run-now').then((r) => r.data);
export const exportBackup = (passphrase) => api.post('/admin/backup/export', { passphrase }, { responseType: 'blob' });
export const restoreBackup = (file, passphrase, mode = 'upsert') => {
  const fd = new FormData();
  fd.append('file', file); fd.append('passphrase', passphrase); fd.append('mode', mode);
  return api.post('/admin/backup/restore', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
};
